module.exports = __webpack_public_path__ + "img/infrastructure-18.3e50663e.png";